// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 291) return "static/css/291.88ab70668c4a249f3f5f.lib.css";
	if (chunkId === 678) return "static/css/678.561c96bb87fcb6272388.css";
	// return url for filenames based on template
	return undefined;
};